import Container from './Container'

export default {
  Container
}



// WEBPACK FOOTER //
// ./src/register/components/index.js